import React from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { Redirect, Route, Switch, useLocation, useRouteMatch } from 'react-router-dom';
import StudentCourseDetail from './screens/StudentCourseDetail';
import StudentFeedback from './screens/StudentFeedback';
import StudentHome from './screens/StudentHome';
import StudentLessonPlayer from './screens/StudentLessonPlayer';
import StudentLogin from './screens/StudentLogin';
import StudentProfile from './screens/StudentProfile';
import StudentSettings from './screens/StudentSettings';
import StudentPronunciation from './screens/StudentPronunciation';
import MockupBanner from '../../MockupBanner';
import mockupTheme from '../../mockupTheme';

// Standalone mobile student experience at /mockup/v2/student — no TopMenuBar (hidden in App.tsx).
export default function StudentApp() {
    const { path } = useRouteMatch();
    const location = useLocation();
    // This prototype is independent of the real account and JWT session.
    if (location.pathname === `${path}/login`) {
        return (
            <ThemeProvider theme={mockupTheme}>
                <MockupBanner surface="Student" />
                <StudentLogin />
            </ThemeProvider>
        );
    }

    // v2 has no settings onboarding gate: the legacy chat-style settings prompts
    // (and Start Class) are deprecated; preferences live on the Settings page.
    const profilePath = `${path}/profile`;

    return (
        <ThemeProvider theme={mockupTheme}>
            <MockupBanner surface="Student" />
            <Switch>
                <Route exact path={path} component={StudentHome} />
                <Route exact path={`${path}/feedback`} component={StudentFeedback} />
                <Route exact path={`${path}/course/:courseId/lesson/:lessonId`}>
                    {/* Keyed by path so finishing one lesson and starting the next remounts the player. */}
                    <StudentLessonPlayer key={location.pathname + location.search} />
                </Route>
                <Route exact path={`${path}/course/:courseId`} component={StudentCourseDetail} />
                <Route exact path={profilePath} component={StudentProfile} />
                <Route exact path={`${path}/settings`} component={StudentSettings} />
                <Route exact path={`${path}/pronunciation`} component={StudentPronunciation} />
                <Redirect to={path} />
            </Switch>
        </ThemeProvider>
    );
}
